$(document).ready(function () {
    $(function() {
        'use strict';
        if (currentUrl.includes('employee')) {
            $('#employeeTable').DataTable({
                "lengthMenu": [[25, 50, 100, -1], [25, 50, 100, "All"]],
                responsive: true,
                colReorder: true,
                "order": [[ 0, "desc" ]],
                language: {
                    search: "<i class='fa fa-search search-icon'></i>",
                    lengthMenu: '_MENU_ ',
                    paginate : {
                        first    : '<i class="fa fa-angle-double-left"></i>',
                        last     : '<i class="fa fa-angle-double-right"></i>',
                        previous : '<i class="fa fa-angle-left"></i>',
                        next     : '<i class="fa fa-angle-right"></i>'
                    }
                },
                pagingType : 'full_numbers',
                processing: true,
                serverSide: true,
                ajax: "/employee",
                columns: [
                    {
                        data: 'serial',
                        name: 'serial',
                        orderable: false,
                        searchable: false
                    },
                    {
                        data: 'fname',
                        name: 'fname',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'lname',
                        name: 'lname',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'status',
                        name: 'status',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'has_account',
                        name: 'has_account',
                        orderable: true,
                        searchable: true
                    },
                    {
                        data: 'actions',
                        name: 'actions',
                        orderable: true,
                        searchable: true
                    }
                ]
            })
        }

    });


    $(document).on('click', '.deleteEmployeeButton', function(e) {
        e.preventDefault();
        var employeeId = $(this).data('id');

        var employeeDestroyBaseUrl = `employee/${employeeId}`;
        var url = employeeDestroyBaseUrl.replace(':employeeId', employeeId);

        swal({
            title: 'Are you sure?',
            text: 'Delete this Employee!',
            icon: 'warning',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    value: null,
                    visible: true,
                    className: 'btn btn-default',
                    closeModal: true,
                },
                confirm: {
                    text: 'Delete',
                    value: true,
                    visible: true,
                    className: 'btn btn-danger',
                    closeModal: true
                }
            }
        }).then((result) => {

            if (result) {
                // User confirmed deletion
                $.ajax({
                    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                    method: 'POST',
                    url: url,
                    data: {'_method': 'DELETE'},
                    success: function(response) {
						if(response.status=='success'){
							swal('Deleted!', response.message, 'success');
						}else{
							swal('Error!', 'Employee Not Found', 'error');
						}

						setTimeout(function () {
							location.reload();
						}, 1000);
		                    },
		                    error: function(error) {
		                        // Handle error
		                        swal('Error!', 'An error occurred while deleting the Employee.', 'error');
		                    }
		                });
            		}
        		});
    		});
});


$(document).ready(function() {
    var makeUser = $('#make_user');
    var selectUser = $('#select_user');
    var userInfo = $('#userInfo');
    var existingUser = $('#existingUser');
    var userId = $('#user_id');
    var role = $('#role');

    makeUser.change(function() {
        if (makeUser.prop('checked')) {
            userInfo.show();
            selectUser.prop('checked', false);
            role.prop('disabled', false);
            existingUser.hide();
        } else {
            userInfo.hide();
            selectUser.prop('checked', false);
            existingUser.hide();
            role.prop('disabled', true);
        }
    });

    selectUser.change(function() {
        if (selectUser.prop('checked')) {
            existingUser.show();
            userId.prop('disabled', false);
            makeUser.prop('checked', false);
            userInfo.hide();
        } else {
            existingUser.hide();
            userId.prop('disabled', true);
            makeUser.prop('checked', false);
            userInfo.hide();
        }
    });

});


$(document).ready(function() {
    var makeUser = $('#make_user');
    var selectUser = $('#select_user');
    var userInfo = $('#userInfo');
    var existingUser = $('#existingUser');
    var userId = $('#user_id');
    var role = $('#role');

    makeUser.change(function() {
        if (makeUser.prop('checked')) {
            userInfo.show();
            selectUser.prop('checked', false);
            role.prop('disabled', false);
            existingUser.hide();
        } else {
            userInfo.hide();
            selectUser.prop('checked', false);
            existingUser.hide();
            role.prop('disabled', true);
        }
    });

    selectUser.change(function() {
        if (selectUser.prop('checked')) {
            existingUser.show();
            userId.prop('disabled', false);
            makeUser.prop('checked', false);
            userInfo.hide();
        } else {
            existingUser.hide();
            userId.prop('disabled', true);
            makeUser.prop('checked', false);
            userInfo.hide();
        }
    });
});
